import apiClient from './client';

const SESSION_ID_KEY = 'iti_analytics_session_id';
const LOGIN_RECORDED_KEY = 'iti_analytics_login_recorded';

export function getOrCreateAnalyticsSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}

export async function recordLoginOnce(): Promise<void> {
  if (sessionStorage.getItem(LOGIN_RECORDED_KEY) === '1') {
    return;
  }
  await apiClient.post('/analytics/login');
  sessionStorage.setItem(LOGIN_RECORDED_KEY, '1');
}

export async function sendHeartbeat(): Promise<void> {
  const sessionId = getOrCreateAnalyticsSessionId();
  await apiClient.post('/analytics/heartbeat', { sessionId });
}
